import React from 'react';
import styled from 'styled-components';

import { DragOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import Tooltip from 'components/Tooltip';

import messages from '../messages';

const StyledHeader = styled.div`
    border-bottom: 1px solid #e0e0e0;
    text-transform: uppercase;
    text-align: center;
    padding: 10px;
    color: #143e44;
    font-family: 'Atlas Grotesk Medium', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const NoFlexStyledHeader = styled.div`
    border-bottom: 1px solid #e0e0e0;
    text-transform: uppercase;
    text-align: center;
    padding: 10px;
    color: #143e44;
    font-family: 'Atlas Grotesk Medium', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 10px;
    justify-content: center;
    align-items: center;
`;

const BetaContainer = styled.span`
    margin-left: 5px;
    color: red;
    font-weight: bold;
    font-size: 10px;
`;

const DragContainer = styled.span`
    float: right;
    font-size: 1.8em;
    margin-top: -0.3em;
    cursor: move;
`;

const Header = ({ show, children, isBeta, isFlex, isDraggable }) => {
    if (!show) return null;

    const betaMention = isBeta && (
        <Tooltip title={<FormattedMessage {...messages.betaTooltip} />}>
            <BetaContainer>
                [<FormattedMessage {...messages.betaLabel} />]
            </BetaContainer>
        </Tooltip>
    );

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    if (!isFlex) {
        return (
            <NoFlexStyledHeader>
                {children}
                {betaMention}
                {dragContainer}
            </NoFlexStyledHeader>
        );
    }

    return (
        <StyledHeader>
            {children}
            {betaMention}
        </StyledHeader>
    );
};

export default Header;
